module.exports = __webpack_public_path__ + "static/media/H.1327788e.png";